let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l8iYW")).then(() => parcelRequire('i0lOb'));